export const isScheduleLive = (schedule: any) => {
    return (
        schedule &&
        schedule.startTime &&
        new Date(schedule.startTime) < new Date() &&
        new Date(schedule.endTime) > new Date()
    );
};
export const isScheduleUpcoming = (schedule: any) => {
    return schedule.startTime && new Date(schedule.startTime) > new Date();
};
export const getScheduleChatChannel = (schedule: any) => {
    return `schedule_${schedule.id}`;
};

export const getScheduleChatUrl = (schedule: any) => {
    return `lcbfc706.ala.us-east-1.emqxsl.com:8084/mqtt`;
};
